import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TrendingStocks = ({ onStockSelect, onAddToWatchlist }) => {
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const trendingStocks = [
    {
      symbol: 'AAPL',
      name: 'Apple Inc.',
      price: 15750.25,
      change: 204.45,
      changePercent: 1.31,
      logo: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=100&h=100&fit=crop&crop=center',
      volume: '52.3M',
      marketCap: '245.5T'
    },
    {
      symbol: 'NVDA',
      name: 'NVIDIA Corporation',
      price: 38023.78,
      change: 1534.45,
      changePercent: 4.21,
      logo: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=100&h=100&fit=crop&crop=center',
      volume: '45.7M',
      marketCap: '93.2T'
    },
    {
      symbol: 'TSLA',
      name: 'Tesla Inc.',
      price: 20440.60,
      change: -740.90,
      changePercent: -3.50,
      logo: 'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=100&h=100&fit=crop&crop=center',
      volume: '89.2M',
      marketCap: '65.0B'
    },
    {
      symbol: 'GOOGL',
      name: 'Alphabet Inc.',
      price: 236934.50,
      change: -1273.30,
      changePercent: -0.53,
      logo: 'https://images.unsplash.com/photo-1573804633927-bfcbcd909acd?w=100&h=100&fit=crop&crop=center',
      volume: '28.9M',
      marketCap: '145.7T'
    },
    {
      symbol: 'MSFT',
      name: 'Microsoft Corporation',
      price: 31520.90,
      change: 471.67,
      changePercent: 1.52,
      logo: 'https://images.unsplash.com/photo-1633419461186-7d40a38105ec?w=100&h=100&fit=crop&crop=center',
      volume: '31.4M',
      marketCap: '234.0T'
    },
    {
      symbol: 'META',
      name: 'Meta Platforms Inc.',
      price: 24834.34,
      change: 601.23,
      changePercent: 2.48,
      logo: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=100&h=100&fit=crop&crop=center',
      volume: '19.8M',
      marketCap: '62.9B'
    }
  ];

  const handleAddToWatchlist = (e, stock) => {
    e.stopPropagation();
    onAddToWatchlist(stock);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-foreground">Trending Stocks</h2>
      </div>
      {/* Responsive grid: never overflows, always fits screen */}
      <div className="w-full max-w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
        {trendingStocks.map((stock) => (
          <div
            key={stock.symbol}
            onClick={() => onStockSelect(stock)}
            className="w-full bg-card border border-border rounded-lg p-4 cursor-pointer hover:shadow-hover transition-all duration-200 hover:-translate-y-1"
          >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center overflow-hidden">
                    <img
                      src={stock.logo}
                      alt={stock.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="w-full h-full bg-primary/10 flex items-center justify-center text-primary font-semibold text-sm" style={{ display: 'none' }}>
                      {stock.symbol.charAt(0)}
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground">{stock.symbol}</h3>
                    <p className="text-sm text-muted-foreground truncate max-w-32">{stock.name}</p>
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => handleAddToWatchlist(e, stock)}
                  className="h-8 w-8 hover:bg-primary/10"
                >
                  <Icon name="Plus" size={16} />
                </Button>
              </div>

              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold font-mono text-foreground">
                    ₹{stock.price.toFixed(2)}
                  </span>
                  <div className={`text-right ${stock.change >= 0 ? 'text-success' : 'text-destructive'}`}>
                    <div className="font-mono text-sm">
                      {stock.change >= 0 ? '+' : ''}₹{stock.change.toFixed(2)}
                    </div>
                    <div className="font-mono text-xs">
                      ({stock.change >= 0 ? '+' : ''}{stock.changePercent.toFixed(2)}%)
                    </div>
                  </div>
                </div>

                <div className="flex justify-between text-sm text-muted-foreground">
                  <span>Volume: {stock.volume}</span>
                  <span>Cap: {stock.marketCap}</span>
                </div>

                {/* Mini Chart Placeholder */}
                <div className="h-12 bg-muted/30 rounded flex items-center justify-center mt-3">
                  <Icon name="TrendingUp" size={16} className="text-muted-foreground" />
                </div>
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingStocks;